import { useState, useEffect, useMemo } from 'react';
import React from 'react';
import { getDmImei, btnSelect_send_sms} from '../../../../redux/actions';
import Indicator from "../../../UI/Indicator/Indicator";
import { useDispatch, useSelector } from 'react-redux';
import { EQUIPMENT_CONFIG_MAP, REVERSE_CONFIG_MAP, DEVICE_SUBTYPE_NAMES } from '../../../Utils/ConfigMaps';
import '../RsConfig.css';

// Вспомогательная функция: получить базовую (без SMS) конфигурацию по типу и подтипу
const getBaseConfigId = (type, subtype) => {
    const configs = EQUIPMENT_CONFIG_MAP[type]?.[subtype];
    return configs ? configs[0] : null; // всегда берём [0] — без SMS
  };

export default React.memo(function SelectConfigRs() {
    const parameter = useSelector((state) => state.dmimei.data[0]);
    const dispatch = useDispatch();

    // Состояние для хранения выбранных значений
    const [selectedType, setSelectedType] = useState(null);
    const [selectedSubTypeIndex, setSelectedSubTypeIndex] = useState(null);


    // Инициализация из Redux
    useEffect(() => {
        if (parameter) {
          const type = Number(parameter.typeRsDevice);
          const configId = parameter.config_id != null ? Number(parameter.config_id) : null;
      
          setSelectedType(type);
      
          const newOptions = EQUIPMENT_CONFIG_MAP[type] || null;
      
          let matchedSubtypeIndex = null;
      
          if (configId != null && newOptions) {
            const reverseEntry = REVERSE_CONFIG_MAP[configId];
            // Проверяем, что config_id соответствует текущему типу
            if (reverseEntry && reverseEntry.type === type) {
              matchedSubtypeIndex = reverseEntry.subtype;
            } else {
              // Если не соответствует — выбираем первый подтип по умолчанию
              matchedSubtypeIndex = Number(Object.keys(newOptions)[0]) || 0;
            }
          } else if (newOptions) {
            // Если config_id нет — тоже выбираем первый
            matchedSubtypeIndex = Number(Object.keys(newOptions)[0]) || 0;
          }
      
          setSelectedSubTypeIndex(matchedSubtypeIndex);
        }
      }, [parameter?.typeRsDevice, parameter?.config_id]);

  const handleClickSaveConfig = async () => {
    if (proposedConfigId === null) {
      console.error('Не удалось определить новую конфигурацию');
      return;
    }

    console.log(`Сохранение конфигурации: cfg_${proposedConfigId} (без SMS)`);
    dispatch(btnSelect_send_sms(parameter?.imei, proposedConfigId))
    .then(() => dispatch(getDmImei(parameter?.imei)))
    .catch((error) => console.error("Ошибка при сохранении или обновлении данных: ", error));
    alert(`Конфигурация сохранена: cfg_${proposedConfigId}`);
  };

        // Обработчик выбора
const handleConfigChange = (e) => {
    const newSubtypeIndex = parseInt(e.target.value, 10);
    setSelectedSubTypeIndex(newSubtypeIndex);
};

    // Опции только для отображения названий подтипов
  const configOptions = useMemo(() => {
    return DEVICE_SUBTYPE_NAMES[selectedType] || [];
  }, [selectedType]);
  
  // Флаг: изменилась ли конфигурация (тип или подтип)?
  const isConfigChanged = useMemo(() => {
    // Если нет данных — не показываем кнопку
    if (parameter?.typeRsDevice == null || parameter?.config_id == null) {
      return false;
    }
  
    const currentType = Number(parameter.typeRsDevice);
    const currentConfigId = Number(parameter.config_id);
  
    // Проверяем: соответствует ли config_id текущему типу?
    const reverseEntry = REVERSE_CONFIG_MAP[currentConfigId];
    const isConfigValidForType = reverseEntry?.type === currentType;
  
    // Если конфигурация НЕ соответствует типу — это точно изменение!
    if (!isConfigValidForType) {
      return true;
    }
  
    // Если соответствует — сравниваем с выбранным состоянием
    if (selectedType === null || selectedSubTypeIndex === null) {
      return false; // ещё не инициализировано
    }
  
    // Сравниваем тип и подтип
    return selectedType !== currentType || selectedSubTypeIndex !== reverseEntry.subtype;
  }, [parameter?.typeRsDevice, parameter?.config_id, selectedType, selectedSubTypeIndex]);
  
  // Предлагаемый config_id (без SMS)
  const proposedConfigId = useMemo(() => {
    if (selectedType !== null && selectedSubTypeIndex !== null) {
      return getBaseConfigId(selectedType, selectedSubTypeIndex);
    }
    return null;
  }, [selectedType, selectedSubTypeIndex]);

    return (
        <>
            <div className='ParamInput'>
                <label>Конфигурация</label>  
                <select 
                      className='DmSelect' 
                         value={selectedSubTypeIndex ?? ''} 
                         onChange={handleConfigChange}
                     disabled={!selectedType || !configOptions.length}
                        >
                     {configOptions.map((text, index) => (
                       <option key={index} value={index}>{text}</option>
                         ))}
                    </select>
            </div>    
            <div className='RsSelectedConfig'>
            {isConfigChanged ? (
                 <div className='newConfig-container'>
                    <div className='RsNewConfig'>
                        Новая конфигурация: cfg_{proposedConfigId} (без SMS)
                    </div>

                    <button className='RsConfigButton' onClick={handleClickSaveConfig}>
                        Сохранить конфигурацию
                    </button>
                 </div> 
            ) : (
                <div className='RsCurrentConfig'>
                    ✓ Текущая конфигурация (cfg_{parameter?.config_id})
                </div>
            )}
                <div className='indicators-modem'>
                    <div className="indicator-container">
                        <Indicator state={parameter?.config_upload==='1' ? 'on_yellow' : 'off'} />
                        Флаг обновления
                    </div>
                    <div className="indicator-container">
                        <Indicator state={parameter?.modem_reset==='1' ? 'on_yellow' : 'off'} />
                        Флаг перезагрузки
                    </div>
                </div>  
            </div>
        </>
    );
});